import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import footballApi from '@infrastructure/football-api';
export const syncNetherlandsFixturesCurrentYearAsync = createAsyncThunk('football/sync-current-year', async (partnerId, { rejectWithValue, dispatch }) => {
    try {
        await footballApi.syncNetherlandsFootballCurrentYear(partnerId);
        return;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
